import type { RouteConfig } from 'vue-router';
import { Role } from '@/modules/shared/types';

const route: RouteConfig = {
    path: '/:customer/loss-of-production-metrics',
    name: 'ctx-admin-loss-of-production_metrics',
    component: () => import(/* webpackChunkName: "ctx-admin-loss-of-production" */ './LossOfProductionMetricsView.vue'),
    meta: {
        role: Role.APP_ADMIN,
        license: [],
        authenticated: true,
        settingsTabs: true,
        settingsTabsGroup: 'company-admin',
        settingsTabsOrder: 40,
        portfolioTabs: false,
        navbar: true,
        footer: true,
        onboarding: true,
        notifications: true,
    },
};

export { route };
